import AddressHistory from "../../../model/addressHistory/AddressHistory";
import {ADDRESS_HISTORY_FETCHED} from "./actionType";
import IndividualContactAddressHistory from "../../../model/addressHistory/IndividualContactAddressHistory";
import {OnFailure, OnSuccess, OnSuccessData} from "../actionHelpers";
import {Dispatch} from "redux";
import {api} from "../../../api/api";
import {Option} from "ts-option";
import * as _ from "underscore";

/**
 * Address history successfully fetched action.
 * @param {string} contactId contact id for which history was fetched.
 * @param {AddressHistory[]} addressHistory address history.
 * @return {Action<ADDRESS_HISTORY_FETCHED>}
 */
function addressHistoryFetched(contactId: string, addressHistory: AddressHistory[]) {
	return {type: ADDRESS_HISTORY_FETCHED, payload: {history: addressHistory, contactId}}
}

/**
 * Address history successfully updated action.
 * @param {string} contactId contact id for which history was fetched.
 * @param {AddressHistory[]} addressHistory address history.
 * @return {Action<ADDRESS_HISTORY_FETCHED>}
 */
function addressHistoryUpdated(contactId: string, addressHistory: AddressHistory[]) {
	return {type: ADDRESS_HISTORY_FETCHED, payload: {history: addressHistory, contactId}}
}

/**
 * Updates address histories for given contacts.
 * Updates histories only if they are given.
 * @param {Option<IndividualContactAddressHistory>} landlordAddressHistories landlord address histories.
 * @param {Option<IndividualContactAddressHistory>} billPayerAddressHistories bill payer address histories.
 */
export function updateAddressHistories(landlordAddressHistories: Option<IndividualContactAddressHistory>,
	billPayerAddressHistories: Option<IndividualContactAddressHistory>,
	onSuccess: OnSuccess,
	onFailure: OnFailure,
	dispatch: Dispatch<any>) {
	const addressHistoriesPromises: Promise<IndividualContactAddressHistory>[] = [];
	const addressesDataToUpdate: IndividualContactAddressHistory[] = [];
	landlordAddressHistories.forEach(histories => addressesDataToUpdate.push(histories));
	// billPayerAddressHistories.forEach(histories => addressesDataToUpdate.push(histories));
	_.uniq(addressesDataToUpdate, value => value.contactId).map(addressToUpdate => {
		addressHistoriesPromises.push(api.instance.contactApi.updateAddressHistory(addressToUpdate))
	});
	Promise.all(addressHistoriesPromises).then((histories: IndividualContactAddressHistory[]) => {
		histories.map(history => {
			dispatch(addressHistoryUpdated(history.contactId, history.history));
		});
		onSuccess();
	}).catch(onFailure);
}

/**
 * Update address history for a single contact.
 * @param {string} contactId contact identifier.
 * @param {AddressHistory[]} history address histories.
 * @param {OnSuccess} onSuccess
 * @param {OnFailure} onFailure
 */
export function updateAddressHistory(contactId: string, history: AddressHistory[], onSuccess: OnSuccess, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		const data = new IndividualContactAddressHistory(contactId, history);
		api.instance.contactApi.updateAddressHistory(data).then(response => {
			dispatch(addressHistoryUpdated(response.contactId, response.history));
			onSuccess();
		}).catch(onFailure);
	}
}

/**
 * Fetch contact address history.
 * @param {string} contactId contact identifier to fetch history.
 */
export function fetchAddressHistory(contactId: string, onSuccess: OnSuccessData<AddressHistory[]>, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.contactApi.fetchAddressHistory(contactId).then(history => {
			dispatch(addressHistoryFetched(contactId, history.history));
			onSuccess(history.history);
		}).catch(onFailure);
	}
}